import { render, staticRenderFns } from "./EventDetailJson.vue?vue&type=template&id=62b1350e&scoped=true&"
import script from "./EventDetailJson.vue?vue&type=script&lang=js&"
export * from "./EventDetailJson.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailJson.vue?vue&type=style&index=0&id=62b1350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1350e",
  null
  
)

export default component.exports